import { __decorate } from "tslib";
import { action, toJS } from 'mobx';
import Cache, { refreshCacheOptions } from './Cache';
const KEY = Symbol('KEY');
export default class PromiseMerger {
    constructor(callback, config, timeout = 200) {
        this.timeout = timeout;
        this.promiseMap = new Map();
        this.cache = new Cache(toJS(config));
        this.callback = callback;
        this.reaction = refreshCacheOptions(this.cache);
    }
    dispose() {
        this.reaction();
    }
    add(code, getBatchKey, args) {
        const { cache, promiseMap } = this;
        const item = cache.get(code);
        if (item) {
            return Promise.resolve(item);
        }
        const batchKey = getBatchKey ? getBatchKey(KEY) : KEY;
        return new Promise((resolve, reject) => {
            const promiseList = promiseMap.get(batchKey) || new Map();
            promiseMap.set(batchKey, promiseList);
            let promise = promiseList.get(code);
            const resolveCallback = () => {
                resolve(cache.get(code));
            };
            if (promise) {
                promise.resolves.push(resolveCallback);
                promise.rejects.push(reject);
            }
            else {
                if (this.waitID) {
                    clearTimeout(this.waitID);
                }
                promise = {
                    resolves: [resolveCallback],
                    rejects: [reject],
                };
                promiseList.set(code, promise);
                this.waitID = setTimeout(() => {
                    const codeList = [...promiseList.keys()];
                    if (process.env.LOGGER_LEVEL === 'info') {
                        // eslint-disable-next-line no-console
                        console.info(`batch request: ${codeList}`);
                    }
                    this.callback(codeList, args)
                        .then(res => {
                        codeList.forEach((key) => {
                            const value = promiseList.get(key);
                            const data = res[key];
                            this.cache.set(key, data);
                            promiseList.delete(key);
                            const { resolves = [] } = value || {};
                            resolves.forEach(r => r(data));
                        });
                    })
                        .catch(error => {
                        codeList.forEach(key => {
                            const value = promiseList.get(key);
                            promiseList.delete(key);
                            const { rejects = [] } = value || {};
                            rejects.forEach(r => r(error));
                        });
                    });
                }, this.timeout);
            }
        });
    }
}
__decorate([
    action
], PromiseMerger.prototype, "add", null);
